import { useMatch } from 'react-router-dom';
import { CSSProperties } from 'react';

import { Visible } from 'coreOld/components';
import { Icon } from 'coreOld/elements';

import { iconStyle, LinkText, Link, Wrapper } from './navItemStyle';

interface IProps {
  url?: string;
  onClick?: () => void;
  icon?: JSX.Element;
  text?: string;
  matchedPath?: string;
  isDropdown?: boolean;
  isDropdownOpen?: boolean;
  isTextHidden?: boolean;
  secondaryNav?: boolean;
  style?: CSSProperties;
  display?: boolean;
}

const NavItemView = ({
  url,
  onClick,
  icon,
  text,
  matchedPath,
  isDropdown,
  isDropdownOpen = false,
  isTextHidden,
  secondaryNav,
  style,
  display = true,
}: IProps) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const isSelected = url ? useMatch({ path: matchedPath || `${url}/*` }) : false;

  return (
    <Wrapper
      selected={Boolean(isSelected)}
      secondaryNav={secondaryNav}
      style={style}
      display={display ? display.toString() : undefined}
    >
      <Link to={url || '#'} onClick={onClick} selected={isSelected} secondaryNav={secondaryNav}>
        <>
          {icon}

          <LinkText isTextHidden={isTextHidden}>{text}</LinkText>

          <Visible when={isDropdown}>
            <Icon name={Icon.ARROW} upsideDown={isDropdownOpen} style={iconStyle} />
          </Visible>
        </>
      </Link>
    </Wrapper>
  );
};

export default NavItemView;
